import { SvgIcon, SxProps, Theme } from "@mui/material";

export default function CustomerSatisfactionAltSvg({
    sx,
}: {
    sx?: SxProps<Theme>;
}) {
    return (
        <SvgIcon
            viewBox="0 0 20 20"
            sx={{ width: 20, height: 20, fill: "none", ...sx }}
        >
            <path
                d="M4.85547 17.5003L6.20964 11.6462L1.66797 7.70866L7.66797 7.18783L10.0013 1.66699L12.3346 7.18783L18.3346 7.70866L13.793 11.6462L15.1471 17.5003L10.0013 14.3962L4.85547 17.5003Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
}
